module.exports = __webpack_public_path__ + "static/ecozebratoy-62129bb11a785a3cb2fd33cad9c65110.jpeg";